import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import { pascalCase } from 'change-case';
import icons from '../../img/icons/icons';

export const isMessage = (message) => isObject(message) && typeof message.id !== 'undefined';

export const shuffle = (array) => {
    if (!isArray(array)) {
        return array;
    }
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex]; // eslint-disable-line
        array[randomIndex] = temporaryValue; // eslint-disable-line
    }
    return array;
};

export const getComponentFromName = (components, name, defaultComponentName = null) => {
    const defaultComponent =
        (isString(defaultComponentName)
            ? components[pascalCase(defaultComponentName)] || components[defaultComponentName]
            : defaultComponentName) || null;
    if (name === null) {
        return defaultComponent;
    }
    const componentName = pascalCase(name);
    return components[componentName] || components[name] || defaultComponent;
};

export const getImageSize = (image, size) =>
    image !== null && image !== undefined
        ? (image.sizes || []).find((it) => it.id === size) || image
        : null;

export const getImageAtSize = (image, size, webp = false) => {
    if (image === null) {
        return null;
    }
    const { sizes: imagesSizes = {}, ...originalImage } = image;
    return (
        [...(isArray(size) ? size : [size]), 'original']
            .reduce(
                (acc, currentSize) =>
                    webp ? [...acc, `${currentSize}_webp`, currentSize] : [...acc, currentSize],
                [],
            )
            .reduce(
                (selectedImage, currentSize) => selectedImage || imagesSizes[currentSize] || null,
                null,
            ) || originalImage
    );
};

export const getImageSizeUrl = (image, size) => {
    const imageAtSize = getImageSize(image, size);
    return imageAtSize !== null ? imageAtSize.url || null : null;
};

export const convertUppyToMedia = (it) => {
    const type = it.data.type.split('/')[0];
    const thumbnail = it.transloadit[`${type}_thumbnail`] || null;
    const original = it.transloadit[`${type}_original`] || null;
    return {
        handle: it.id,
        type,
        name: it.meta.name,
        mime: it.data.type,
        size: it.data.size,
        url: original !== null ? original.ssl_url || original.url : null,
        thumbnail_url: thumbnail !== null ? thumbnail.ssl_url || thumbnail.url : null,
        metadata: {
            ...(original !== null ? original.meta || null : null),
            filename: it.meta.filename,
            transloadit: it.transloadit.results || null,
        },
    };
};

export const getUniqueArray = (array, key = 'id') => {
    if (!isArray(array)) {
        return array;
    }
    const uniqueIds = [];
    return array.filter((item) => {
        const valid = uniqueIds.indexOf(item[key]) === -1;
        uniqueIds.push(item.id);
        return valid;
    });
};

export const addNonBreakingSpaces = (str) => str.replace(/&nbsp;/g, '\u00a0');

export const cleanExternalLinks = (str) =>
    str !== null
        ? str.replace(/(<a\\b[^<>]*href=['"]?http[^<>]+)>/gi, '$1 target="_blank">')
        : null;

export const replaceIcons = (body) => {
    const parsedBody = Object.keys(icons).reduce(
        (currentBody, iconKey) =>
            currentBody.replace(
                `:${iconKey}:`,
                `\u00a0<img src="${icons[iconKey]}" style="display: inline-block;
                max-height: 1.2em;
                vertical-align: middle;" />\u00a0`,
            ),
        cleanExternalLinks(body),
    );

    return parsedBody;
};

export const createSteps = (steps = 1) => [...Array(steps + 1)].map((_, i) => i / steps);

export const capitalizeFirstLetter = (string) =>
    string ? string.charAt(0).toUpperCase() + string.slice(1) : null;

export const removeTagsInString = (str) => {
    if (str === null || str === '') {
        return false;
    }
    const newString = str.toString();
    return newString.replaceAll(/(<([^>]+)>)/gi, '');
};

export const getTextAtSpecificLength = (length, text) => {
    let cleanText = removeTagsInString(text);
    while (cleanText.length < length) {
        cleanText += cleanText;
    }
    const words = cleanText.slice(0, length).split(' ');
    words.pop();
    return words.join(' ');
};

export const sluggify = (str) => {
    let newStr = str.replace(/^\s+|\s+$/g, '');
    newStr = newStr.toLowerCase();

    const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
    const to = 'aaaaaeeeeeiiiiooooouuuunc------';
    for (let i = 0, l = from.length; i < l; i += 1) {
        newStr = newStr.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    newStr = newStr
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

    return newStr;
};

export const padStart = (string, maxLength, add = '') => {
    const str = String(string);
    if (str.length >= maxLength) {
        return str;
    }

    let fillString = String(add);
    if (fillString.length === 0) {
        fillString = ' ';
    }

    const fillLen = maxLength - str.length;
    const timesToRepeat = Math.ceil(fillLen / fillString.length);
    const truncatedStringFiller = fillString.repeat(timesToRepeat).slice(0, fillLen);
    return truncatedStringFiller + str;
};
